"use strict";
exports.__esModule = true;
exports.getErrorFromCatch = void 0;
var getErrorFromCatch = function (err) {
    if (err instanceof Error)
        return err;
    var unknownError = new Error('Non-error caught. See this.unknown for details.');
    unknownError.unknown = err;
    return unknownError;
};
exports.getErrorFromCatch = getErrorFromCatch;
//# sourceMappingURL=getErrorFromCatch.js.map